<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo" style="font-size: 17px;">
        <img src="../assets/img/logorgb.svg" alt="" />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          class="item"
          :class="{ active: active === index }"
          @click="scrollTo(index)"
          v-for="(item, index) in navList"
          :key="item.id"
        >
          <a href="javascript:;" @click="navJump(item, $event)">
            {{ item.title }}
            <i class="underline"></i>
          </a>
        </li>
      </ul>
    </div>

    <!-- 手机导航 -->
    <div class="header-nav container-fuild visible-xs df-ac-jc"></div>
  </div>
</template>
<script>
export default {
  name: "Header",
  props: {
    navList: {
      type: Array,
      default: () => [],
    },
    active: {
      type: Number,
      default: 0,
    },
    isScroll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    navJump(item, event) {
      event.preventDefault(); // 阻止a标签默认跳转
      if (item.url) {
        this.$router.push(item.url);
      }
    },
    // 跳转到指定索引的元素
    scrollTo(index) {
      console.log(this.isScroll);
      if (!this.isScroll) return;
      console.log('9999999');
      if (index == 0) {
        let timer = setInterval(function() {
          var top =
            document.body.scrollTop || document.documentElement.scrollTop;
          var speed = top / 4;
          if (document.body.scrollTop != 0) {
            document.body.scrollTop -= speed;
          } else {
            document.documentElement.scrollTop -= speed;
          }
          if (top == 0) {
            clearInterval(timer);
          }
        }, 30);
        return;
      }
      // 获取目标的 offsetTop
      // css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
      const targetOffsetTop = document.querySelector(
        `.content .item:nth-child(${index + 1})`
      ).offsetTop;
      // 获取当前 offsetTop
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
      const STEP = 50;
      // 判断是往下滑还是往上滑
      if (scrollTop > targetOffsetTop) {
        // 往上滑
        smoothUp();
      } else {
        // 往下滑
        smoothDown();
      }
      // 定义往下滑函数
      function smoothDown() {
        // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
        // if (scrollTop < targetOffsetTop) {
        if (scrollTop < targetOffsetTop) {
          // 如果和目标相差距离大于等于 STEP 就跳 STEP
          // 否则直接跳到目标点，目标是为了防止跳过了。
          if (targetOffsetTop - scrollTop >= STEP) {
            scrollTop += STEP;
          } else {
            scrollTop = targetOffsetTop;
          }
          document.body.scrollTop = scrollTop;
          document.documentElement.scrollTop = scrollTop;
          // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
          requestAnimationFrame(smoothDown);
        }
      }
      // 定义往上滑函数
      function smoothUp() {
        if (scrollTop > targetOffsetTop) {
          if (scrollTop - targetOffsetTop >= STEP) {
            scrollTop -= STEP;
          } else {
            scrollTop = targetOffsetTop;
          }
          document.body.scrollTop = scrollTop;
          document.documentElement.scrollTop = scrollTop;
          requestAnimationFrame(smoothUp);
        }
      }
    },
  },
};
</script>
<style scoped>
@import "../assets/css/header.scss";
</style>
